import getNowDate from '@sdk/utils/getNowDate';
import { differenceInMinutes } from 'date-fns';
import { useEffect, useState } from 'react';

import breakOrangeIcon from '@kiosk/assets/svg/icons/break-orange.svg';
import TimesheetEntryBaseRow from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/TimesheetEntryBaseRow/TimesheetEntryBaseRow';
import { getDisplayDuration } from '@kiosk/utils/Utils';

type Props = { label: string; startTimestampLocal: Date; delay: number };

const DynamicBreakEntryRow = ({ label, startTimestampLocal, delay }: Props) => {
  const actualMinutes = differenceInMinutes(getNowDate(), startTimestampLocal);
  const [breakDuration, setBreakDuration] = useState<number>(actualMinutes);
  const isVisible = breakDuration >= 1;

  useEffect(() => {
    const interval = setInterval(() => {
      setBreakDuration(differenceInMinutes(getNowDate(), startTimestampLocal));
    }, 60 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [startTimestampLocal]);

  if (!isVisible) {
    return null;
  }

  return (
    <TimesheetEntryBaseRow
      icon={breakOrangeIcon as string}
      label={label}
      contentTxt={getDisplayDuration(breakDuration)}
      delay={delay}
    />
  );
};

export default DynamicBreakEntryRow;
